// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"CustomerProfile_mainContent__3zVCq"};